import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { LUBRIFICACAO, MODULO_20_GRAUS } from '~/constants/modules';
import { t, number, can } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteProduto,
  findProduto,
  recordFiltering,
} from '~/store/modules/produto/actions';

import Form from './form';

function ProdutoList() {
  const redux = useSelector((state) => state.produto);

  const tipocalculoDencidade = useMemo(
    () => [
      {
        label: 0,
        value: t('s.configuracao.produto.calculodensidadeproduto.naocalcula'),
      },
      {
        label: 1,
        value: t('s.configuracao.produto.calculodensidadeproduto.alcoolanidro'),
      },
      {
        label: 2,
        value: t(
          's.configuracao.produto.calculodensidadeproduto.alcoolhidratado'
        ),
      },
      {
        label: 3,
        value: t('s.configuracao.produto.calculodensidadeproduto.gasolina'),
      },
      {
        label: 4,
        value: t('s.configuracao.produto.calculodensidadeproduto.diesel'),
      },
      {
        label: 5,
        value: t('s.configuracao.produto.calculodensidadeproduto.biodiesel'),
      },
    ],
    []
  );

  const tipoProduto = useMemo(
    () => [
      { label: 'C', value: t('s.geral.opcoes.combustivel') },
      { label: 'L', value: t('s.geral.opcoes.lubrificante') },
      { label: 'G', value: t('s.geral.opcoes.graxa') },
    ],
    []
  );

  const header = useMemo(() => {
    const data = [
      {
        id: 'idproduto',
        label: t('s.configuracao.produto.idproduto'),
        filter: { type: 'number' },
      },
      {
        id: 'codigoauxiliarproduto',
        label: t('s.configuracao.produto.codigoauxiliarproduto'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeproduto',
        label: t('s.configuracao.produto.nomeproduto'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeabreviadoproduto',
        label: t('s.configuracao.produto.nomeabreviadoproduto'),
        filter: { type: 'text' },
      },
      {
        id: 'precoprecoproduto',
        label: t('s.configuracao.produto.precoproduto'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
    ];

    if (can(LUBRIFICACAO)) {
      data.splice(3, 0, {
        id: 'tipoproduto',
        label: t('s.configuracao.produto.tipoproduto'),
        formatted: (value) =>
          tipoProduto.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: tipoProduto },
      });
    }

    if (can(MODULO_20_GRAUS)) {
      data.splice(4, 0, {
        id: 'calculodensidadeproduto',
        label: t('s.configuracao.produto.calculodensidadeproduto'),
        formatted: (value) =>
          tipocalculoDencidade.find((s) => s.label === value).value || '',
      });
    }

    return data;
  }, []);

  const fieldlist = [
    'codigoauxiliarproduto',
    'nomeproduto',
    'nomeabreviadoproduto',
    'precoprecoproduto',
  ];

  const substituirHeader = {
    codigoauxiliarproduto: t('s.configuracao.produto.codigoauxiliarproduto'),
    nomeproduto: t('s.configuracao.produto.nomeproduto'),
    nomeabreviadoproduto: t('s.configuracao.produto.nomeabreviadoproduto'),
    precoprecoproduto: t('s.configuracao.produto.precoproduto'),
  };

  if (can(MODULO_20_GRAUS)) {
    fieldlist.push('calculodensidadeproduto');
    substituirHeader.calculodensidadeproduto = t(
      's.configuracao.produto.calculodensidadeproduto'
    );
  }

  if (can(LUBRIFICACAO)) {
    fieldlist.push('tipoproduto');
    substituirHeader.tipoproduto = t('s.configuracao.produto.tipoproduto');
  }

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findProduto}
      remove={deleteProduto}
      form={Form}
      keys="idproduto"
      detach="nomeabreviadoproduto"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'produtos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Produtos',
          substituirValores: {
            calculodensidadeproduto: {
              '0': t(
                's.configuracao.produto.calculodensidadeproduto.naocalcula'
              ),
              '1': t(
                's.configuracao.produto.calculodensidadeproduto.alcoolanidro'
              ),
              '2': t(
                's.configuracao.produto.calculodensidadeproduto.alcoolhidratado'
              ),
              '3': t('s.configuracao.produto.calculodensidadeproduto.gasolina'),
              '4': t('s.configuracao.produto.calculodensidadeproduto.diesel'),
              '5': t(
                's.configuracao.produto.calculodensidadeproduto.biodiesel'
              ),
            },
            tipoproduto: {
              C: t('s.geral.opcoes.combustivel'),
              L: t('s.geral.opcoes.lubrificante'),
              G: t('s.geral.opcoes.graxa'),
            },
          },
        })
      }
    />
  );
}

export default ProdutoList;
